/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImageAndMaskResponse
 */
export interface ImageAndMaskResponse {
    /**
     * 
     * @type {string}
     * @memberof ImageAndMaskResponse
     */
    imagePath: string;
    /**
     * 
     * @type {string}
     * @memberof ImageAndMaskResponse
     */
    maskPath: string;
}

export function ImageAndMaskResponseFromJSON(json: any): ImageAndMaskResponse {
    return ImageAndMaskResponseFromJSONTyped(json, false);
}

export function ImageAndMaskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageAndMaskResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imagePath': json['imagePath'],
        'maskPath': json['maskPath'],
    };
}

export function ImageAndMaskResponseToJSON(value?: ImageAndMaskResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'imagePath': value.imagePath,
        'maskPath': value.maskPath,
    };
}


